var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGoogleplay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 52,
    viewBox: "0 0 180 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M173.095 52H6.6575C2.99754 52 0 49.0734 0 45.5V6.5C0 2.92663 2.99754 2.74817e-06 6.6575 2.74817e-06H173.095C176.755 2.74817e-06 179.753 2.92663 179.753 6.5V45.5C179.753 49.0734 176.755 52 173.095 52Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M173.095 1.04162C176.177 1.04162 178.686 3.4905 178.686 6.5V45.5C178.686 48.5095 176.177 50.9584 173.095 50.9584H6.6575C3.57508 50.9584 1.06686 48.5095 1.06686 45.5V6.5C1.06686 3.4905 3.57508 1.04162 6.6575 1.04162H173.095ZM173.095 2.74817e-06H6.6575C2.99754 2.74817e-06 0 2.92663 0 6.5V45.5C0 49.0734 2.99754 52 6.6575 52H173.095C176.755 52 179.753 49.0734 179.753 45.5V6.5C179.753 2.92663 176.755 2.74817e-06 173.095 2.74817e-06Z",
    fill: "#A6A6A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1364 13.3169C63.1364 14.4024 62.8035 15.2717 62.1478 15.9201C61.3938 16.6887 60.4118 17.0755 59.2085 17.0755C58.0584 17.0755 57.0764 16.6822 56.2709 15.9071C55.4636 15.1206 55.0609 14.1554 55.0609 13C55.0609 11.8446 55.4636 10.8794 56.2709 10.0994C57.0764 9.31775 58.0584 8.9245 59.2085 8.9245C59.781 8.9245 60.327 9.03987 60.8479 9.25437C61.3672 9.4705 61.7899 9.763 62.0962 10.1237L61.4005 10.8095C60.8662 10.1936 60.1389 9.88975 59.2085 9.88975C58.3697 9.88975 57.6423 10.1757 57.0248 10.7526C56.414 11.3311 56.1078 12.0802 56.1078 13C56.1078 13.9197 56.414 14.6754 57.0248 15.2539C57.6423 15.8242 58.3697 16.1167 59.2085 16.1167C60.0989 16.1167 60.8479 15.8242 61.4388 15.2474C61.8282 14.8655 62.0496 14.339 62.1078 13.6662H59.2085V12.727H63.0765C63.1231 12.9301 63.1364 13.1267 63.1364 13.3169Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.273 10.0604H65.6396V12.5304H68.9151V13.4696H65.6396V15.9396H69.273V16.8967H64.611V9.10324H69.273V10.0604Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6037 16.8967H72.5751V10.0604H70.3465V9.10324H75.8339V10.0604H73.6037V16.8967Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8051 16.8967V9.10324H80.8321V16.8967H79.8051Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3841 16.8967H84.3638V10.0604H82.1269V9.10324H87.621V10.0604H85.3841V16.8967Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0101 15.8941C97.2228 16.6822 96.2475 17.0755 95.0841 17.0755C93.9141 17.0755 92.9387 16.6822 92.1515 15.8941C91.3659 15.1076 90.9748 14.1424 90.9748 13C90.9748 11.8576 91.3659 10.8924 92.1515 10.1059C92.9387 9.31775 93.9141 8.9245 95.0841 8.9245C96.2409 8.9245 97.2162 9.31775 98.0034 10.1124C98.7957 10.9054 99.1868 11.8641 99.1868 13C99.1868 14.1424 98.7957 15.1076 98.0101 15.8941ZM92.9121 15.2409C93.5046 15.8242 94.2253 16.1167 95.0841 16.1167C95.9363 16.1167 96.6636 15.8242 97.2495 15.2409C97.8403 14.6575 98.1399 13.9084 98.1399 13C98.1399 12.0916 97.8403 11.3425 97.2495 10.7591C96.6636 10.1757 95.9363 9.88325 95.0841 9.88325C94.2253 9.88325 93.5046 10.1757 92.9121 10.7591C92.3213 11.3425 92.0217 12.0916 92.0217 13C92.0217 13.9084 92.3213 14.6575 92.9121 15.2409Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M100.63 16.8967V9.10324H101.878L105.759 15.1645H105.804L105.759 13.6662V9.10324H106.786V16.8967H105.714L101.65 10.5365H101.605L101.65 12.0412V16.8967H100.63Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7218 28.2783C87.5944 28.2783 85.0396 30.602 85.0396 33.8082C85.0396 36.9883 87.5944 39.3364 90.7218 39.3364C93.8558 39.3364 96.4106 36.9883 96.4106 33.8082C96.4106 30.602 93.8558 28.2783 90.7218 28.2783ZM90.7218 37.1589C89.0058 37.1589 87.5295 35.776 87.5295 33.8082C87.5295 31.8143 89.0058 30.4558 90.7218 30.4558C92.4377 30.4558 93.9207 31.8143 93.9207 33.8082C93.9207 35.776 92.4377 37.1589 90.7218 37.1589ZM78.3238 28.2783C75.1898 28.2783 72.6417 30.602 72.6417 33.8082C72.6417 36.9883 75.1898 39.3364 78.3238 39.3364C81.4562 39.3364 84.006 36.9883 84.006 33.8082C84.006 30.602 81.4562 28.2783 78.3238 28.2783ZM78.3238 37.1589C76.6062 37.1589 75.1249 35.776 75.1249 33.8082C75.1249 31.8143 76.6062 30.4558 78.3238 30.4558C80.0398 30.4558 81.5161 31.8143 81.5161 33.8082C81.5161 35.776 80.0398 37.1589 78.3238 37.1589ZM63.5708 29.9732V32.3229H69.3179C69.1498 33.6359 68.7004 34.6012 68.0114 35.2739C67.1725 36.0864 65.866 36.9883 63.5708 36.9883C60.034 36.9883 57.2645 34.2014 57.2645 30.7483C57.2645 27.2952 60.034 24.5083 63.5708 24.5083C65.4832 24.5083 66.8746 25.2379 67.9015 26.1837L69.5975 24.5278C68.1612 23.1888 66.2505 22.1602 63.5708 22.1602C58.7208 22.1602 54.6448 26.013 54.6448 30.7483C54.6448 35.4835 58.7208 39.3364 63.5708 39.3364C66.1922 39.3364 68.1612 38.4979 69.709 36.9249C71.2952 35.3763 71.7895 33.1988 71.7895 31.4405C71.7895 30.8945 71.7429 30.3924 71.6597 29.9732H63.5708ZM123.898 31.7948C123.43 30.5582 121.987 28.2783 119.048 28.2783C116.135 28.2783 113.71 30.5192 113.71 33.8082C113.71 36.9054 116.11 39.3364 119.327 39.3364C121.929 39.3364 123.43 37.7878 124.048 36.8859L122.117 35.6298C121.473 36.5495 120.596 37.1589 119.327 37.1589C118.067 37.1589 117.164 36.595 116.584 35.4835L124.159 32.4236L123.898 31.7948ZM116.175 33.6359C116.11 31.5039 117.871 30.4119 119.133 30.4119C120.121 30.4119 120.96 30.8945 121.24 31.5852L116.175 33.6359ZM110.019 39H112.508V22.75H110.019V39ZM105.941 29.51H105.858C105.298 28.8633 104.232 28.2783 102.88 28.2783C100.044 28.2783 97.4508 30.7093 97.4508 33.826C97.4508 36.9249 100.044 39.3364 102.88 39.3364C104.232 39.3364 105.298 38.7465 105.858 38.0803H105.941V38.8733C105.941 40.9874 104.784 42.1233 102.918 42.1233C101.397 42.1233 100.453 41.0508 100.064 40.1489L97.8985 41.0313C98.5227 42.497 100.175 44.3008 102.918 44.3008C105.838 44.3008 108.301 42.6238 108.301 38.5434V28.6147H105.941V29.51ZM103.093 37.1589C101.377 37.1589 99.9407 35.7565 99.9407 33.826C99.9407 31.8777 101.377 30.4558 103.093 30.4558C104.784 30.4558 106.117 31.8777 106.117 33.826C106.117 35.7565 104.784 37.1589 103.093 37.1589ZM135.555 22.75H129.6V39H132.083V32.8429H135.555C138.313 32.8429 141.018 30.8945 141.018 27.7957C141.018 24.6984 138.306 22.75 135.555 22.75ZM135.62 30.5825H132.083V25.0104H135.62C137.474 25.0104 138.533 26.5135 138.533 27.7957C138.533 29.0534 137.474 30.5825 135.62 30.5825ZM150.97 28.2474C149.176 28.2474 147.311 29.0209 146.543 30.7353L148.747 31.6372C149.221 30.7353 150.093 30.4428 151.015 30.4428C152.304 30.4428 153.61 31.1984 153.63 32.5325V32.7032C153.181 32.4497 152.219 32.0743 151.035 32.0743C148.662 32.0743 146.244 33.3499 146.244 35.7305C146.244 37.908 148.188 39.3104 150.373 39.3104C152.044 39.3104 152.966 38.5743 153.545 37.7179H153.63V38.974H156.029V32.7405C156.029 29.8594 153.825 28.2474 150.97 28.2474ZM150.671 37.1524C149.859 37.1524 148.727 36.7592 148.727 35.776C148.727 34.5183 150.138 34.0357 151.36 34.0357C152.453 34.0357 152.966 34.2713 153.63 34.5817C153.435 36.0864 152.109 37.1524 150.671 37.1524ZM164.766 28.6033L161.912 35.6477H161.827L158.876 28.6033H156.198L160.632 38.4475L158.102 43.9254H160.697L167.529 28.6033H164.766ZM142.382 39H144.872V22.75H142.382V39Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8942 9.80036C13.5031 10.2001 13.2767 10.8225 13.2767 11.6285V40.378C13.2767 41.184 13.5031 41.8064 13.8942 42.2061L13.9907 42.2939L30.4914 26.1901V25.8099L13.9907 9.70611L13.8942 9.80036Z",
    fill: "url(#paint0_linear_1_33)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9855 31.5607L30.4913 26.1901V25.8099L35.9921 20.4392L36.1153 20.5091L42.6296 24.128C44.4887 25.155 44.4887 26.845 42.6296 27.8785L36.1153 31.4908L35.9855 31.5607Z",
    fill: "url(#paint1_linear_1_33)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1153 31.4909L30.4914 26L13.8942 42.2061C14.5117 42.8399 15.5186 42.9162 16.6637 42.2825L36.1153 31.4909Z",
    fill: "url(#paint2_linear_1_33)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1153 20.5091L16.6637 9.71751C15.5186 9.09025 14.5117 9.16663 13.8942 9.80038L30.4914 26L36.1153 20.5091Z",
    fill: "url(#paint3_linear_1_33)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_33",
    x1: 29.0263,
    y1: 40.6774,
    x2: 7.21544,
    y2: 18.338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_33",
    x1: 45.0505,
    y1: 25.9982,
    x2: 12.8323,
    y2: 25.9982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_33",
    x1: 33.0572,
    y1: 23.0151,
    x2: 3.47986,
    y2: -7.27893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_33",
    x1: 9.71636,
    y1: 51.7709,
    x2: 22.924,
    y2: 38.2434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleplay);
export default __webpack_public_path__ + "static/media/googleplay.7ee019b8866a2e1b05a7fafddbc3ad0d.svg";
export { ForwardRef as ReactComponent };